/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path context
 * @description User context with the profile
 * Hook for creating links inside the app
 *
 * @evaluation good
 * @category Context providers
 *
 */
import { UserInfo } from "@qpr/client-library";
import React from "react";
type Profile = {
  profile?: {
    _id: string;
    meaLogonName: string;
    meaUserId: string;
    fullName: string;
    email: string;
    organization: string;
    role: string;
    uiRole: string;
    landingUrl: string;
    landingTitle: string;
    createdAt: {
      $date: string;
    };
    lastLoginAt: string;
    logins: number;
    tenantAdmin: boolean;
  };
};
export const UserContext = React.createContext({} as UserInfo & Profile);
export default () => React.useContext(UserContext);
